import { connect } from 'react-redux'
import {
  BulkWrapper,
  createPostPlacement,
  updatePostPlacement,
  destroyPostPlacement,
  getPlacements,
} from '@opallabs/wormhole'
import PostMetaSelects from '.'

const mapStateToProps = (state, props) => {
  const appState = new BulkWrapper(state)

  if (appState.content) {
    const post = appState.content.find((c) => c.id === props.postId)
    const placements = appState.placement || []
    const accountPlacements = placements
      .filter((p) => p.account && p.account.id === props.accountId)
      .sort((a, b) => a.position - b.position)

    return {
      post,
      placements: accountPlacements,
    }
  }

  return { ...props }
}

const mapDispatchToProps = (dispatch) => ({
  createPostPlacement: (options) => dispatch(createPostPlacement(options)),
  updatePostPlacement: (options) => dispatch(updatePostPlacement(options)),
  destroyPostPlacement: (options) => dispatch(destroyPostPlacement(options)),
  getPlacements: (options) => dispatch(getPlacements(options)),
})

const ConnectedPostMetaSelects = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostMetaSelects)

export default ConnectedPostMetaSelects
